import { useContext } from 'react';
import AnimateHeight from '@/common/AnimateHeight';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import { CommonWrapper } from './FiltersMenu.styles';

export default function CabTypes() {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();

  const show = Boolean(
    facetData.truckCabTypes?.buckets &&
      facetData.truckCabTypes?.buckets?.length > 0
  );

  return (
    <AnimateHeight show={show}>
      <FilterDrawer
        testId="facet-cab-type"
        facetContent={facetData.truckCabTypes?.buckets}
        facetName="Cab Option"
      >
        <CommonWrapper>
          {facetData.truckCabTypes?.buckets?.map(
            ({ count, displayName, key }) => (
              <Checkbox
                facet="truckCabTypes"
                filter={key}
                id={`cab-type-${key}`}
                key={key}
                label={
                  showInventoryCounts
                    ? `${displayName} (${count.toLocaleString()})`
                    : displayName
                }
                checked={appliedFilters.truckCabTypes?.includes(key)}
                onChange={() =>
                  updateListFilter({
                    filterKey: 'truckCabTypes',
                    value: key
                  })
                }
              />
            )
          )}
        </CommonWrapper>
      </FilterDrawer>
    </AnimateHeight>
  );
}
